// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1_3NE","button":"styles_button__2sQnV"};